<script setup lang="ts">
import { getEnv, isLg, } from '@/utils/env';
import { onBeforeMount } from 'vue';
import {  useSessionStore, } from '@/store';
import { onMounted } from 'vue';
const sessionStore = useSessionStore();

onBeforeMount(async () => {
  const env = await getEnv();

  sessionStore.getAccessToken();

  if (env && env !== 'prod') {
    const { default: VConsole, } = await import('vconsole');

    // eslint-disable-next-line no-new
    new VConsole();
  }
});

onMounted(() => {
  window.onload = function () {
    document.addEventListener("touchstart", function (event) {
      if (event.touches.length > 1) {
        event.preventDefault();
      }
    });
    document.addEventListener("gesturestart", function (event) {
      event.preventDefault();
    });
  };
});
</script>

<template>
  <div class="routers">
    <router-view></router-view>
  </div>
</template>

<style lang="scss">

</style>

<style lang="scss" scoped>

</style>
